import { toast } from 'react-toastify'

export namespace MoovyToast {
  export const showToast = (
    message: string | React.ReactNode,
    type: 'success' | 'error' = 'success',
  ): void => {
    switch (type) {
      case 'success':
        toast.success(message)
        break
      case 'error':
        toast.error(message)
        break
    }
  }
}
